import { PropsWithChildren } from 'react';
import { ActionType } from '@mews-commander/enums';
import { ModalWrapper, NewModalBodyWrapper } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { IconName } from '@optimus-web/icons';
import ModalHeader, { ModalHeaderProps } from '../../legacy/React/Components/Common/ModalHeader';
import { HeadingAction } from '../../legacy/React/Components/HeadingAction/Action/types';

export interface BaseLayoutProps extends Omit<ModalHeaderProps, 'children'> {
    padded?: boolean;
    guideLink?: string;
    headerContent?: React.ReactNode;
}
/** @deprecated Use PageLayout instead */
export const BaseLayout = ({
    children,
    padded,
    guideLink,
    headerContent,
    actions = [],
    ...other
}: PropsWithChildren<BaseLayoutProps>) => {
    const modalHeaderActions: HeadingAction[] = guideLink
        ? [
              ...actions,
              {
                  url: guideLink,
                  target: '_blank',
                  icon: IconName.Help,
                  text: lt('Help'),
                  type: ActionType.Link,
                  actionId: 'help',
              },
          ]
        : actions;

    return (
        <ModalWrapper>
            <ModalHeader {...other} actions={modalHeaderActions}>
                {headerContent}
            </ModalHeader>
            <NewModalBodyWrapper padded={padded}>{children}</NewModalBodyWrapper>
        </ModalWrapper>
    );
};
